import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

import { Z_INDEX_HIGH } from '@Styles/constants/layout'
import { RADIUS_1 } from '@Styles/constants/radius'

export const autocompleteContainer = css({
  position: 'relative',
})

export const autocomplete = (theme: Theme): SerializedStyles =>
  css({
    overflow: 'auto',
    position: 'absolute',
    top: theme.spacing(1),
    zIndex: Z_INDEX_HIGH,
  })

export const autocompleteWithBorder = (theme: Theme): SerializedStyles =>
  css({
    border: `1px solid ${theme.customPalette.onElements.outline}`,
  })

export const error = (theme: Theme): SerializedStyles =>
  css({
    borderRadius: RADIUS_1,
    outline: `2px solid ${theme.palette.error.main}`,
  })

export const errorMessageWrapper = (theme: Theme): SerializedStyles =>
  css({
    margin: theme.spacing(1, '0'),
  })
